import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import MilkMoneyAccountingService from '~/api/services/milkMoneyAccounting'
import ProfileSettingsService from '~/api/services/profileSettings'
import Dialog from '~/components/Dialog'
import notify from '~/components/Notify'
import TwoFaComp from '~/components/TwoFaComp'
import { useAuth } from '~/routes/components/AuthProvider'
import { getUsersBrowserData, handleErrors } from '~/utils/helpers'

interface Props {
  isOpenCloseMonthDialog: boolean
  handleClose: (submitted?: boolean) => void
  selectedPeriod: string
  selectedPeriodId: string | number
}

const CloseMonth: React.FC<Props> = (props) => {
  const { t } = useTranslation()
  const { isOpenCloseMonthDialog, handleClose, selectedPeriod, selectedPeriodId } = props
  const { systemData } = useAuth()
  const tfaCloseMonth = systemData?.roleSettings?.tfaMgaCloseMonth === 1
  const tfaType = systemData?.logged?.tfaType

  const [isBusy, setIsBusy] = useState(false)
  const [correctTfaCode, setCorrectTfaCode] = useState(false)
  const [tfaCode, setTfaCode] = useState('')

  useEffect(() => {
    if (tfaCloseMonth && isOpenCloseMonthDialog) {
      handleSendCode()
    }
  }, [isOpenCloseMonthDialog])

  async function handleSendCode() {
    if (tfaType === 'email' || tfaType === 'sms') {
      setIsBusy(true)
      try {
        await ProfileSettingsService.sendCode()
        notify(t('Code sent'), 'success')
      } catch (error) {
        handleErrors(error)
      }
      setIsBusy(false)
    }
  }

  async function handleCloseMonth(data?) {
    setIsBusy(true)
    try {
      const userData = getUsersBrowserData()
      await MilkMoneyAccountingService.closeAdditionalPaymentMonth({ periodId: selectedPeriodId, ...userData, ...data })
      notify(t('Successfully closed month'), 'success')
      handleClose(true)
    } catch (error) {
      handleErrors(error)
    }
    setIsBusy(false)
  }

  return <Dialog
    textContent={<>
      <div>
        {t('Please make sure that all delivery and billing data is correct and that you have imported the SEPA XML into your banking program. \n\
        After the month-end closing, no changes can be made to the milk payment statements for {{month}}.', { month: selectedPeriod })}
      </div>
      {tfaCloseMonth && <TwoFaComp
        onChangeTfaCode={(code) => setTfaCode(code)}
        onChangeCorrectTfaCode={(correctTfaCode) => setCorrectTfaCode(correctTfaCode)}
      />}
    </>}
    type='abort'
    isDialogOpen={isOpenCloseMonthDialog}
    style={{ minWidth: 620 }}
    disableSubmit={isBusy || tfaCloseMonth ? !correctTfaCode : false}
    isLoading={isBusy}
    handleSubmit={() => handleCloseMonth(tfaCloseMonth ? { code: tfaCode } : null)}
    handleClose={() => handleClose()}
    textHeader={t('Close billing month for {{month}}', { month: selectedPeriod })}
    textClose={t('Cancel')}
    textSubmit={t('Complete the billing month')}
  />
}
export default CloseMonth